import(/* webpackMode: "eager" */ "/app/apps/ashtrom-base/app/[locale]/not-found.tsx");
